import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';

@Component({
  selector: 'app-side-bar-finance-benin',
  templateUrl: './side-bar-finance-benin.component.html',
  styleUrls: ['./side-bar-finance-benin.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarFinanceBeninComponent {
  constructor(
    private router: Router,
    private appelservice: AppelsService,
  ) {}
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;
  nomrole!: string;
  isFcc: boolean = false;
  isCom: boolean = false;
  isBoard: boolean = false;
  isSEV: boolean = false;
  isStemd: boolean = false;
  isFinance: boolean = false;
  isFinanceBenin: boolean = true;
  isAipen: boolean = false;
  urlScholarVox = 'https://skills.scholarvox.com/forcen';
  urlFondAmorcage: string = 'https://fa.force-n.sn/auth/login/keycloak';

  urlClasseVirtuelle: string =
    'https://formation.force-n.sn/mod/bigbluebuttonbn/view.php?id=43470';
  urlSoftSkills: string =
    'https://formation.force-n.sn/course/view.php?id=1239';

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];
  listFamily: any;
  listofftrack: any;
  ngOnInit() {
    this.getFamily();
    this.getOfftrack();
    this.user = sessionStorage.getItem('user');
    console.log('********user: ', this.user);
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;
    this.cohorte = JSON.parse(
      this.user,
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
        sessionStorage.setItem('nomrole', this.nomrole);
        switch (element.roleName) {
          case 'gestionnaire': {
            this.isFcc = true; // Gestionnaire FCC
            break;
          }
          case 'suivi': {
            this.isSEV = true; // Gestionnaire Suivi Evaluation
            break;
          }
          case 'finance': {
            this.isFinance = true; //Gestionnaire Finance
            break;
          }
          case 'aipen': {
            this.isAipen = true; //Gestionnaire AIPEN
            break;
          }

          case 'stemd': {
            this.isStemd = true; //Gestionnaire Stemd
            break;
          }

          case 'com': {
            this.isCom = true; //Gestionnaire Com
            break;
          }

          case 'board': {
            this.isBoard = true; // Programme Board
            break;
          }

          case 'gestionnaire-finance-benin': {
            this.isFinanceBenin = true; // Gestionnaire Finance Benin
            break;
          }
        }
      });
    }

    // console.log('user role: ', this.user);
  }

  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }
  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }

  sessionChangeHparcours(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidaturesHS/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidaturesHS/' + cohorte);
    }, 500);
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }
  getFamily() {
    this.appelservice.getFamiliesWithCohortes().subscribe({
      next: (data: any[]) => {
        this.listFamily = data.map((family) => ({
          ...family,
          isCollapsed: true,
        }));
        console.log(this.listFamily);
      },
      error: (error) => {
        console.error(error);
        alert("Une erreur s'est produite lors de la récupération des données");
      },
    });
  }
  getOfftrack() {
    this.appelservice.getOffTractWithCohortes().subscribe({
      next: (data: any[]) => {
        this.listofftrack = data.map((family) => ({
          ...family,
          isCollapsed: true,
        }));
      },
      error: (error) => {
        console.error(error);
        alert("Une erreur s'est produite lors de la récupération des données");
      },
    });
  }
  toggleOfftrack(offtrack: any) {
    offtrack.isCollapsed = !offtrack.isCollapsed;
  }
}
